import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WaitlistPage from "./pages/WaitlistPage";
import ThankYouPage from "./pages/ThankYouPage";
import ConfirmPage from "./pages/ConfirmPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<WaitlistPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/confirm" element={<ConfirmPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
